<app-question-card>
  <p question>
    Great. <br />
    We can help with that too!
  </p>
  <form input-options #buyingPrefForm="ngForm">
    <div class="box-c mb-20">
      <p>
        Please let us know where you are looking to buy. It will help us match you to the best agent in that area. Your perfect agent will
        work for you, on your goals, to help with one of the biggest financial decisions of your life.
      </p>
    </div>
    <div class="form-field mb-3">
      <input type="text" placeholder="Enter city, zip" name="buyingArea" required [(ngModel)]="buyingArea" [maxLength]="64" />
    </div>
    <label class="mb-1 d-block">Enter range of home prices</label>
    <div class="flex-box-center mb-3">
      <div class="form-field prefix" input-options data-prefix="$">
        <lib-amount-comma-separated
          class="text-right"
          placeholder="0"
          required
          name="low"
          [(ngModel)]="buyingPriceLow"
          [libMin]="0"
          [libMax]="100000000"
        ></lib-amount-comma-separated>
      </div>
      <p class="px-10">-</p>
      <div class="form-field prefix" input-options data-prefix="$">
        <lib-amount-comma-separated
          class="text-right"
          placeholder="0"
          required
          name="high"
          [(ngModel)]="buyingPriceHigh"
          [libMin]="0"
          [libMax]="100000000"
        ></lib-amount-comma-separated>
      </div>
    </div>
  </form>
  <p class="chat-answer text-capitalize" answer *ngIf="!skipped">
    {{ buyingArea }} <br />
    {{ buyingPriceLow! | formatPrice }} - {{ buyingPriceHigh! | formatPrice }}
  </p>
  <p class="chat-answer" answer *ngIf="skipped">No thanks</p>
  <button class="w-100" footer (click)="next()" [disabled]="buyingPrefForm.invalid || !rangeValid">Continue</button>
  <button class="w-100 mt-3 button-primary" footer (click)="skip()">No thanks</button>
</app-question-card>
